import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react'
import { CustomButton, TextField } from '../../../v2/MUI_custom_component';
import AuthCardContainer from './AuthCardContent';
import { registerAction } from './API/Action';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { NAME_REGEX, PINCODE_REGEX } from './Components/regex';
import { useDispatch, useSelector } from 'react-redux';
import { onLoggedIn } from '../../../v2/Function/onLoggedIn';
import { decodeToken } from '../../../utils/settings';


const RegDetails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [name, setName] = React.useState('');
    const [shopPincode, setShopPincode] = React.useState('');
    const [nameErr, setNameErr] = React.useState('');
    const [pincodeErr, setPincodeErr] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const isValidName = val => NAME_REGEX.test(val.trim()) && !/^\s/.test(val) && val.trim().length > 0;
    const isValidPincode = val => PINCODE_REGEX.test(val.trim()) && val.trim()[0] !== '0';
    const [tokenData, setTokenData] = React.useState(null);
    const isFilled =
        isValidName(name) &&
        isValidPincode(shopPincode);
    const token = localStorage.getItem('token');
    const handleRegister = async () => {
        let valid = true;
        if (!name) {
            setNameErr("Name is required");
            valid = false;
        } else if (/^\s/.test(name)) {
            setNameErr("Name should not start with a space");
            valid = false;
        } else if (!isValidName(name)) {
            setNameErr("Name must contain only alphabets");
            valid = false;
        } else {
            setNameErr("");
        }
        if (!shopPincode) {
            setPincodeErr("Pincode is required");
            valid = false;
        } else if (shopPincode[0] === '0') {
            setPincodeErr("Pincode cannot start with 0");
            valid = false;
        } else if (!isValidPincode(shopPincode)) {
            setPincodeErr("Pincode must be 6 digits");
            valid = false;
        } else {
            setPincodeErr("");
        }
        if (!valid) return;
        
        if (!token) {
            toast.error("Authentication token not found. Please login again.");
            // navigate('/login');
            return;
        }
        if (!tokenData || !tokenData.user_id) {
            toast.error("Invalid token data. Please login again.");
            // navigate('/login');
            return;
        }
        
        setLoading(true);
        const payload = { 
            user_id: tokenData.user_id,
            name, 
            pincode: shopPincode 
        };
        const { error, message } = await registerAction(payload, token);
        setLoading(false);
        if(!error){
            onLoggedIn({
                data: {
                    token: token
                },
                navigate,
                dispatch,
                toast
            });
        }else{
            toast.error(message);
        }
    };
    useEffect(() => {
        const getTokenData = async () => {
          if (token) {
            try {
              const decoded = await decodeToken(token);
              setTokenData(decoded);
            } catch (err) {
              console.error('Failed to decode token', err);
            }
          }
        };
        getTokenData();
    }, [token]);  
    return (
        <AuthCardContainer showLogo={false}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Typography variant='h1' sx={{ color: '#666666' }}>Account Details</Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <Box
                        component='img'
                        src='https://d2djimvzddgguw.cloudfront.net/onboarding/add-firm.svg'
                        alt='Account Details'
                        sx={{ width: '100%', maxHeight: 200, objectFit: 'contain' }}
                    />
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <Typography variant='h2'>Enter account Information</Typography>
                        <TextField
                            label="Name*"
                            value={name}
                            onChange={e => {
                                let val = e.target.value.replace(/[^A-Za-z ]/g, "");
                                if (val.length === 1 && val[0] === ' ') val = '';
                                setName(val);
                            }}
                            placeholder="Enter your name"
                            error={!!nameErr}
                            helperText={nameErr}
                        />
                        <TextField
                            label="Shop Pincode*"
                            value={shopPincode}
                            onChange={e => {
                                let val = e.target.value.replace(/\D/g, "").slice(0, 6);
                                if (val.length > 0 && val[0] === '0') val = '';
                                setShopPincode(val);
                            }}
                            placeholder="Enter your shop area pincode eg. 110064"
                            error={!!pincodeErr}
                            helperText={pincodeErr}
                        />
                    </Box>
                    <CustomButton 
                        variant='filled'
                        disabled={loading || !isFilled}
                        label='Done'
                        fullWidth
                        onClick={handleRegister}
                    />
                </Box>
            </Box>
        </AuthCardContainer>
    );
}

export default RegDetails